
import IndexModel from "@/service/v10/sigap/IndexModel"; 

class EnderecoService extends IndexModel { 
      
    constructor() {
        super(); 
        this.url =  this.url + '/Disciplina' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
  
    public getTodasDaTurma( turmaId  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/Turma/' + turmaId    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
     
  
}
  
export default EnderecoService; 